import React from 'react'
import ReturnOrderDetails from './ReturnOrderDetails'
import ReceiveOrderDetails from './ReceiveOrderDetails'
import { getWarehouseType } from "../../helper/utils";

const warehouseType = getWarehouseType();

const Details = () => {
  return (
    <div>
      {
        warehouseType === "central"? <ReceiveOrderDetails/>:<ReturnOrderDetails/>
      }
    </div>
  )
}

export default Details
